<agr-page-toolbar
  [pageTitle]="'product-overview.title' | translate"
  [hasPrimaryAction]="true"
  primaryActionIcon="add"
  [primaryActionText]="'add' | translate"
  (primaryAction)="createProduct()"
  data-test="product-overview"
  [isEmpty]="(products$ | async)?.length === 0"
  [emptyTitle]="'product-overview.no-products.title' | translate"
  [emptyDescription]="'product-overview.no-products.description' | translate"
  emptyImage="assets/images/flock-cycle.jpg"
>
  <ng-container actions>
    <div class="spacing--margin-right">
      <agr-filter [config]="filterConfig"></agr-filter>
    </div>

    <div class="flex__child--auto spacing--margin-right flex--row text--small">
      <mat-form-field
        class="flex__child--auto spacing--margin-right countrySelector"
        subscriptSizing="dynamic"
      >
        <mat-select
          [hideSingleSelectionIndicator]="true"
          class="text--small"
          data-placeholder="{{ 'product-overview.country' | translate }}"
          data-test="product-overview-country-selector"
          (selectionChange)="changeCountrySelection($event)"
          [value]="selectedCountry$ | async"
        >
          <mat-option *ngFor="let country of countries" [value]="country.id">
            {{ 'countries.' + country.id | translate }}
          </mat-option>
        </mat-select>
      </mat-form-field>
    </div>
  </ng-container>

  <div class="wrapper--spacing-horizontal">
    <agr-table *ngIf="(isLoading$ | async) === false" [config]="tableConfig" class="table">
    </agr-table>
    <ng-template #columnActiveTemplate let-row="row">
      <mat-slide-toggle
        [hideIcon]="true"
        class="spacing--margin-left"
        data-test="product__overview-toggle-active"
        color="primary"
        [checked]="row.isActive"
        (change)="onToggleActive(row)"
      >
      </mat-slide-toggle>
    </ng-template>
    <ng-template #columnTypeTemplate let-row="row">
      <span class="value">{{
        'product-overview.overview.productType-' + row.type | translate
      }}</span>
    </ng-template>
  </div>
</agr-page-toolbar>
